import {fetchPromises} from "../../core/utils/fetchPromises";

function CategoryMenu({ categories, onClick, selectedCategoryId, location }) {
    const currentPath = location.pathname.split("/")[1];
    return (
        <>
            {categories.map((b, index) =>
                <li
                    key={index}
                    onClick={onClick}
                    data-to={`/${currentPath}/${b.id}`}
                    className={b.id === +selectedCategoryId ? 'selected' : ''}
                >
                    {b.name}
                </li>
            )}
        </>
    );
}
export default fetchPromises({
    categories: () => ({ name: 'getCategories' })
})(CategoryMenu);
